import maxIcon from '@images/socials/max.svg?raw'
import maxQr from '@images/socials/max-qr.svg?url'
import telegramIcon from '@images/socials/telegram.svg?raw'
import telegramQr from '@images/socials/telegram-qr.svg?url'
import vkIcon from '@images/socials/vk.svg?raw'
import vkQr from '@images/socials/vk-qr.svg?url'

export interface ISocialLink {
  id: 'telegram' | 'vk' | 'max'
  /** Название для подсказки и aria-label иконки */
  title: string
  /** Подзаголовок модалки с QR-кодом */
  subtitle: string
  url: string
  /** Цвет из темы (`theme.ts`) */
  color: string
  icon: string
  qr: string
}

/** Сообщества DAO-MED.ru для футера сайдбара. Ссылки совпадают с теми, что зашиты в QR-коды */
export const SOCIAL_LINKS: ISocialLink[] = [
  {
    id: 'telegram',
    title: 'Telegram',
    subtitle: 'Подпишитесь на канал Telegram',
    url: 'https://t.me/DAOMEDru',
    color: 'telegram',
    icon: telegramIcon,
    qr: telegramQr,
  },
  {
    id: 'vk',
    title: 'ВКонтакте',
    subtitle: 'Подпишитесь на группу ВКонтакте',
    url: 'https://vk.ru/DAOMEDru',
    color: 'vk',
    icon: vkIcon,
    qr: vkQr,
  },
  {
    id: 'max',
    title: 'MAX',
    subtitle: 'Подпишитесь на сообщество MAX',
    url: 'https://max.ru/id274395030_biz2',
    color: 'max',
    icon: maxIcon,
    qr: maxQr,
  },
]
